import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=7567a2bf&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"
import style0 from "./Order.vue?vue&type=style&index=0&id=7567a2bf&prod&lang=css"
import style1 from "./Order.vue?vue&type=style&index=1&id=7567a2bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7567a2bf",
  null
  
)

export default component.exports